import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { MenuTrigger, Button, Popover, Menu, MenuItem } from 'react-aria-components';
import { NavigateRoutes } from '@features/routing/routesObject';
import { SALES_NETWORK_LANGUAGES } from '@@/languageConfig';



const BigMenu = () => {
	const { t } = useTranslation('web');

	const navigate = useNavigate();

	return (
		<div className='header-section big-menu-section'>
			<nav>
				<Link to={NavigateRoutes.about} className='app-main-button disable-selection'>
					{t('layouts.header.aboutUs')}
				</Link>
			
				<MenuTrigger>

					<Button className='order-signpost-button app-main-button disable-selection' autoFocus={false}>
						{t('shared.orderLong')}
					</Button>

					<Popover>
						<Menu onAction={(key: string | number) => navigate(String(key))} autoFocus={false}>

							<MenuItem id={NavigateRoutes.order} textValue={t('layouts.header.dogForm')}>
								<Link to={NavigateRoutes.order}>{t('layouts.header.dogForm')}</Link>
							</MenuItem>

							<MenuItem id={NavigateRoutes.catOrder} textValue={t('layouts.header.catForm')}>
								<Link to={NavigateRoutes.catOrder}>{t('layouts.header.catForm')}</Link>
							</MenuItem>

						</Menu>
					</Popover>
				</MenuTrigger>
			
				<Link to={NavigateRoutes.gallery} className='app-main-button disable-selection'>
					{t('layouts.header.gallery')}
				</Link>
			
				<Link to={NavigateRoutes.partners} className='app-main-button disable-selection'>
					{t('layouts.header.forPartners')}
				</Link>

				<Link to={NavigateRoutes.faq} className='app-main-button disable-selection'>
					{t('layouts.header.faq')}
				</Link>

				{SALES_NETWORK_LANGUAGES && SALES_NETWORK_LANGUAGES.length > 0 &&
					<Link to={NavigateRoutes.salesNetwork} className='app-main-button disable-selection'>
						{t('layouts.header.salesNetwork')}
					</Link>
				}
			</nav>
		</div>
	);
}

export default BigMenu;